import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { OngoingRequestsService } from '../services';

@Injectable()
export class OngoingRequestsInterceptor implements HttpInterceptor {
    constructor(private ongoingRequestsService: OngoingRequestsService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        this.ongoingRequestsService.addRequest(request);

        return next.handle(request).pipe(
            finalize(() => {
                this.ongoingRequestsService.removeRequest(request);
            }),
        );
    }
}
